const React = require("react");
const { default: Snackbar } = require("material-ui/Snackbar");
const Classes = require("./styles.scss");

module.exports = class AppSnackbar extends React.PureComponent {
    render() {
        const { ...others } = this.props;

        return (
            <Snackbar
                className={Classes.snackbarStyles}
                autoHideDuration={5500}
                {...others}
            />
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Snackbar/index.js